import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  SovosSlidingPanel, SovosSlidingPanelHeader, SovosSlidingPanelHeaderActionButtons, SovosRaisedButton
} from 's1-ui';
import XIcon from 'commonComponents/xIcon';
import LicenseFormDisplayField from './LicenseFormDisplayField';

const styles = {
  iconButton: {
    height: 30
  }
};

export const UnstyledLicensePanelDisplay = ({
  licensePanelOpen, closePanel, saveWithClose, saveWithoutClose, value, onChange, errors, panelLabel, availableLicenses
}) => (
  <div>
    <SovosSlidingPanel
      className="CCP__LicensePanel__Display"
      open={ licensePanelOpen }
      onClose={ closePanel }
      baseWidth="600px"
    >
      <SovosSlidingPanelHeader title={ panelLabel }>
        <SovosSlidingPanelHeaderActionButtons>
          <SovosRaisedButton
            color="primary"
            onClick={ saveWithoutClose }
          >
            ADD ANOTHER
          </SovosRaisedButton>
          <SovosRaisedButton
            color="primary"
            onClick={ saveWithClose }
          >
            SAVE
          </SovosRaisedButton>
          <XIcon onClick={ closePanel } />
        </SovosSlidingPanelHeaderActionButtons>
      </SovosSlidingPanelHeader>
      <LicenseFormDisplayField
        availableLicenses={ availableLicenses }
        value={ value }
        errors={ errors }
        onChange={ onChange }
      />
    </SovosSlidingPanel>
  </div>
);

UnstyledLicensePanelDisplay.propTypes = {
  closePanel: PropTypes.func.isRequired,
  licensePanelOpen: PropTypes.bool.isRequired,
  value: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  saveWithClose: PropTypes.func.isRequired,
  saveWithoutClose: PropTypes.func.isRequired,
  panelLabel: PropTypes.string,
  availableLicenses: PropTypes.array
};

UnstyledLicensePanelDisplay.defaultProps = {
  panelLabel: undefined,
  availableLicenses: undefined
};
export default withStyles(styles)(UnstyledLicensePanelDisplay);
